export const fleetTabsData = [
    {
        "img": "sailBoats",
        "id": "01",
        "key": "sail_boats_tab",
        "capacity": "6-8 Guests",
        "badge": "TRADITIONAL ELEGANCE",
        "name": "Sail Boats",
        "des": "Experience the timeless charm of traditional sailing with our wooden deck sailboats. Perfect for intimate gatherings and peaceful cruising along Mumbai's coastline.",
        "list": [
            "Classic sailing experience",
            "Intimate atmosphere",
            "Perfect for photography",
            "Eco-friendly option"
        ],
        "info": [
            {
                "technicalSpecifications": {
                    "length": "35-40 feet",
                    "beam": "12 feet",
                    "draft": "5 feet",
                    "cruisingSpeed": "6-8 knots"
                },
                "featuresAndAmenities": {
                    "coreFeatures": [
                        "Traditional teak wood decking",
                        "Classic sail rigging",
                        "Compact seating areas",
                        "Basic galley facilities",
                        "Safety equipment included",
                        "Life jackets for all guests"
                    ],
                    "premiumAmenities": [
                        "Shaded seating area",
                        "Basic refreshment service",
                        "Bluetooth audio system",
                        "Professional crew"
                    ]
                },
                "perfectFor": [
                    "Couples and small groups",
                    "Pre-wedding photoshoots",
                    "Peaceful sunset cruises",
                    "Romantic occasions",
                    "Nature photography"
                ],
                "bookingNotice": "48 hours minimum",
                "departurePoint": "Gateway of India"
            }
        ]
    },
    {
        "img": "sailYachts",
        "id": "02",
        "key": "sail_yachts_tab",
        "capacity": "15-35 Guests",
        "badge": "SOPHISTICATED LUXURY",
        "name": "Sail Yachts",
        "des": "Elevate your celebration with our spacious luxury sail yachts. Combining traditional sailing with modern amenities for an unforgettable experience.",
        "list": [
            "Spacious deck areas",
            "Premium interiors",
            "Full catering facilities",
            "Entertainment ready"
        ],
        "info": [
            {
                "technicalSpecifications": {
                    "length": "50-65 feet",
                    "beam": "16 feet",
                    "draft": "6.5 feet",
                    "cruisingSpeed": "8-10 knots"
                },
                "featuresAndAmenities": {
                    "coreFeatures": [
                        "Spacious main deck with lounge seating",
                        "Luxurious interior cabins",
                        "Professional galley kitchen",
                        "Multiple bathrooms",
                        "Advanced navigation systems",
                        "Emergency safety equipment"
                    ],
                    "premiumAmenities": [
                        "Air-conditioned interior spaces",
                        "Premium sound system",
                        "LED lighting setup",
                        "Catering preparation area",
                        "Bar counter",
                        "Professional crew (Captain + 2 staff)"
                    ]
                },
                "perfectFor": [
                    "Corporate events and team building",
                    "Family celebrations",
                    "Sunset dinner parties",
                    "Wedding proposals",
                    "Anniversary celebrations",
                    "Birthday parties (mid-size groups)"
                ],
                "bookingNotice": "48 hours minimum",
                "departurePoint": "Gateway of India"
            }
        ]
    },
    {
        "img": "motorYachts",
        "id": "03",
        "key": "motor_yachts_tab",
        "capacity": "15-25 Guests",
        "badge": "ULTIMATE PRESTIGE",
        "name": "Motor Yachts",
        "des": "Experience the pinnacle of luxury with our modern motor yachts. State-of-the-art amenities, climate control, and opulent interiors for your most prestigious events.",
        "list": [
            "Modern luxury design",
            "Climate controlled",
            "Premium amenities",
            "VIP experience"
        ],
        "info": [
            {
                "technicalSpecifications": {
                    "length": "55-70 feet",
                    "beam": "18 feet",
                    "draft": "4.5 feet",
                    "cruisingSpeed": "15-20 knots"
                },
                "featuresAndAmenities": {
                    "coreFeatures": [
                        "Contemporary interior design",
                        "Multiple climate-controlled cabins",
                        "Sundeck with lounge furniture",
                        "Professional galley with modern appliances",
                        "Master suite available",
                        "Advanced stabilization systems"
                    ],
                    "premiumAmenities": [
                        "Full air conditioning throughout",
                        "Premium audio-visual system",
                        "Smart lighting control",
                        "Luxury bathroom facilities",
                        "Mini bar and wine cooler",
                        "Dining area for formal meals",
                        "Professional crew (Captain + 3 staff)",
                        "Water sports equipment (on request)"
                    ]
                },
                "perfectFor": [
                    "High-end corporate events",
                    "Luxury birthday celebrations",
                    "VIP client entertainment",
                    "Exclusive private dinners",
                    "Celebrity events",
                    "Milestone celebrations"
                ],
                "bookingNotice": "48 hours minimum",
                "departurePoint": "Gateway of India"
            }
        ]
    },
    {
        "img": "speedBoats",
        "id": "04",
        "key": "speed_boats_tab",
        "capacity": "6-12 Guests",
        "badge": "THRILLING ADVENTURE",
        "name": "Speed Boats",
        "des": "Feel the adrenaline rush with our high-performance speed boats. Perfect for adventure seekers and quick coastal tours with style and excitement.",
        "list": [
            "High-speed thrills",
            "Modern design",
            "Quick tours",
            "Adventure ready"
        ],
        "info": [
            {
                "technicalSpecifications": {
                    "length": "28-35 feet",
                    "beam": "10 feet",
                    "draft": "3 feet",
                    "cruisingSpeed": "35-45 knots"
                },
                "featuresAndAmenities": {
                    "coreFeatures": [
                        "Powerful twin engines",
                        "Aerodynamic hull design",
                        "Comfortable sport seating",
                        "Open and shaded deck options",
                        "GPS navigation",
                        "Marine radio communication"
                    ],
                    "premiumAmenities": [
                        "Premium seating with safety harnesses",
                        "Waterproof storage compartments",
                        "Bluetooth sound system",
                        "Safety equipment and life jackets",
                        "Experienced captain",
                        "Photography-friendly platforms"
                    ]
                },
                "perfectFor": [
                    "Adventure enthusiasts",
                    "Quick coastal sightseeing",
                    "Island hopping tours",
                    "Photography expeditions",
                    "Small group celebrations",
                    "Adrenaline experiences"
                ],
                "bookingNotice": "48 hours minimum",
                "departurePoint": "Gateway of India"
            }
        ]
    },
    {
        "img": "ferryBoats",
        "id": "05",
        "key": "ferry_boats_tab",
        "capacity": "100 Guests",
        "badge": "LARGE GROUPS",
        "name": "Ferry Boats",
        "des": "Ideal for large gatherings and transport. Our ferry boats offer spacious decks and reliable service for big groups.",
        "list": [
            "Large capacity",
            "Stable cruising",
            "Open decks",
            "Event ready"
        ],
        "info": [
            {
                "technicalSpecifications": {
                    "length": "80-100 feet",
                    "beam": "25 feet",
                    "draft": "8 feet",
                    "cruisingSpeed": "10-12 knots"
                },
                "featuresAndAmenities": {
                    "coreFeatures": [
                        "Large open deck",
                        "Seating for 100+",
                        "Sound system suitable for announcements",
                        "Basic lighting",
                        "Safety railings"
                    ],
                    "premiumAmenities": [
                        "DJ setup space",
                        "Dance floor area",
                        "Catering tables setup",
                        "Decorative lighting options"
                    ]
                },
                "perfectFor": [
                    "Large corporate outings",
                    "Wedding transport",
                    "College reunions",
                    "Religious groups",
                    "Large tour groups"
                ],
                "bookingNotice": "72 hours minimum",
                "departurePoint": "Gateway of India"
            }
        ]
    }
];
